import { render, staticRenderFns } from "./InpatientWorksheetActivityAudits.vue?vue&type=template&id=524d7ac0&"
import script from "./InpatientWorksheetActivityAudits.vue?vue&type=script&lang=js&"
export * from "./InpatientWorksheetActivityAudits.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports